import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

export default createStore({
  state: {
    login: false,
    user: null,
    saltKey: import.meta.env.VITE_SALT_KEY,
    schema: [], 
 units: [], 
 ders: [], 
 sinif: [], 
 ai: [],
    exams: [],
    examsUser: [],
    examQuestions: [],
    userExamQuestions: [],
    questions: [],
    users: [],
    contacts: [],
    tasks: [],
    mermaid: [],
    solved: [],
    solvedTimes: [],
    userExamsSolveds: [],
    sinifs: [],
    dersler: [],
    units: [],
    selectedUnit: null,
    lastDocuments: [],
    // AI Settings
    aiSettings: {
      activeAI: 'gemini', // gemini, openai, anthropic, cohere, ollama, grok
      apiKeys: {
        gemini: import.meta.env.VITE_GEMINI_API_KEY || '',
        openai: import.meta.env.VITE_OPENAI_API_KEY || '',
        anthropic: import.meta.env.VITE_ANTHROPIC_API_KEY || '',
        cohere: import.meta.env.VITE_COHERE_API_KEY || '',
        ollama: import.meta.env.VITE_OLLAMA_API_KEY || 'http://localhost:11434',
        grok: import.meta.env.VITE_GROK_API_KEY || ''
      },
      models: {
        gemini: {
          selected: 'gemini-1.5-flash',
          available: ['gemini-1.5-flash', 'gemini-1.5-pro', 'gemini-1.5-pro-vision']
        },
        openai: {
          selected: 'gpt-4o-mini',
          available: ['gpt-4o-mini', 'gpt-4o', 'gpt-4-turbo', 'gpt-3.5-turbo']
        },
                  anthropic: {
            selected: 'claude-3-5-haiku-20241022',
            available: ['claude-3-5-haiku-20241022']
          },
        cohere: {
          selected: 'command-r',
          available: ['command-r', 'command-r-plus']
        },
        ollama: {
          selected: 'llama3:8b',
          available: ['llama3:8b', 'codellama:7b', 'mistral:7b', 'neural-chat:7b', 'gemma:2b', 'phi:2.7b']
        },
        grok: {
          selected: 'grok-1',
          available: ['grok-1', 'grok-1.5', 'grok-2', 'grok-2-mini']
        }
      },
      settings: {
        temperature: 0.7,
        topK: 40,
        topP: 0.95,
        maxOutputTokens: 1024,
        streaming: false
      }
    }
  },
  mutations: {
    setLogin(state, login) {
      state.login = login;
    },
    setUser(state, user) {
      console.log("user :>> ", user);
      state.user = user;
    },
    logoutUser(state) {
      state.user = null;
    },
    addContacts(state, contacts) {
      state.contacts = [...contacts];
    },
    addQuestions(state, questions) {
      state.questions = [...questions];
    },
    addExams(state, exams) {
      state.exams = [...exams];
    },
    addExamsUser(state, examsUser) {
      state.examsUser = [...examsUser];
    },
    addExamQuestions(state, examQuestions) {
      state.examQuestions = [...examQuestions];
    },
    addUserExamQuestions(state, userExamQuestions) {
      state.userExamQuestions = [...userExamQuestions];
    },
    addLastDocuments(state, lastDocument) {
      state.lastDocuments = [...state.lastDocuments.filter(item => item.unit !== lastDocument.unit), lastDocument];
    },
    deleteLastDocuments(state, unit) {
      state.lastDocuments = state.lastDocuments.filter(item => item.unit !== unit);
    },
    addAi(state, ai) { 
 state.ai = [...ai]; 
}, 
 addSinif(state, sinif) { 
 state.sinif = [...sinif]; 
}, 
 addDers(state, ders) { 
 state.ders = [...ders]; 
}, 
 addUnits(state, units) { 
 state.units = [...units]; 
}, 
 addSchema(state, schema) {
      state.schema = [...schema];
    },
    addUsers(state, users) {
      state.users = [...users];
    },
    addTasks(state, tasks) {
      state.tasks = [...tasks];
    },
    addMermaid(state, mermaid) {
      state.mermaid = [...mermaid];
    },
    addSinif(state, sinifs) {
      state.sinifs = [...sinifs];
    },
    addDers(state, dersler) {
      state.dersler = [...dersler];
    },
    addUnits(state, units) {
      state.units = [...units];
    },
    addMermaidItem(state, item) {
      state.mermaid.push(item);
    },
    updateMermaidItem(state, updatedItem) {
      const index = state.mermaid.findIndex(
        (item) => item.id === updatedItem.id
      );
      if (index !== -1) {
        state.mermaid.splice(index, 1, updatedItem);
      }
    },
    deleteMermaidItem(state, id) {
      state.mermaid = state.mermaid.filter((item) => item.id !== id);
    },
    addSolved(state, solved) {
      state.solved = [...solved];
    },  
    addSolvedTime(state, solvedTime) {
      state.solvedTimes = [...solvedTime];
    },
    addUserExamsSolveds(state, userExamsSolveds) {
      state.userExamsSolveds = [...userExamsSolveds];
    },
    setSelectedUnit(state, selectedUnit) {
      state.selectedUnit = selectedUnit;
    },
    setAiSettings(state, settings) {
      state.aiSettings = { ...state.aiSettings, ...settings };
    },
    setActiveAI(state, ai) {
      state.aiSettings.activeAI = ai;
    },
    setApiKey(state, { ai, key }) {
      state.aiSettings.apiKeys[ai] = key;
    },
    setAiModel(state, { ai, model }) {
      state.aiSettings.models[ai].selected = model;
    },
    setAiGenerationSettings(state, settings) {
      state.aiSettings.settings = { ...state.aiSettings.settings, ...settings };
    }
  },
  getters: {
    _getLogin: (state) => state.login,
    _isAuthenticated: (state) => state.user !== null,
    _getCurrentUser(state) {
      const user = state.user;

      delete user?.password;
      return user;
    },
    _currentUserId: (state) => state?.user?.id,
    _getCurrentRole: (state) => parseInt(state?.user?.role),
    _saltKey: (state) => state.saltKey,
    _getContacts: (state) => state?.contacts,
    _getQuestions: (state) => state?.questions,
    _getExamQuestions: (state) => state?.examQuestions,
    _getUserExamQuestions: (state) => state?.userExamQuestions,
    _getExams: (state) => state?.exams,
    _getExamsUser: (state) => state?.examsUser,
    _getAi: (state) => state?.ai, 
   _getSinif: (state) => state?.sinif, 
 _getDers: (state) => state?.ders, 
 _getUnits: (state) => state?.units, 
 _getSchema: (state) => state?.schema,
    _getUsers: (state) => state?.users,
    _getTasks: (state) => state?.tasks,
    _getMermaid: (state) => state?.mermaid,
    _getSolved: (state) => state?.solved,
    _getSolvedTimes: (state) => state?.solvedTimes,
    _getUserExamsSolveds: (state) => state?.userExamsSolveds,
    _getSinif: (state) => state?.sinifs,
    _getDers: (state) => state?.dersler,
    _getUnits: (state) => state?.units,
    _getSelectedUnit: (state) => state?.selectedUnit,
    _getLastDocuments: (state) => state?.lastDocuments,
    _getAiSettings: (state) => state.aiSettings,
    _getActiveAI: (state) => state.aiSettings.activeAI,
    _getApiKeys: (state) => state.aiSettings.apiKeys,
    _getAiModels: (state) => state.aiSettings.models,
    _getAiGenerationSettings: (state) => state.aiSettings.settings,
    _getCurrentApiKey: (state) => state.aiSettings.apiKeys[state.aiSettings.activeAI],
    _getCurrentModel: (state) => state.aiSettings.models[state.aiSettings.activeAI]?.selected
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
